export const AUTH_LOGOUT = '/auth/logout'
export const AUTH_REFRESH_TOKEN = '/auth/refresh'
export const AUTH_LOGIN_PDS = '/auth/login/pds'
export const AUTH_VERIFICATION = token => `/auth/verification/${token}`
export const AUTH_INFO = '/auth/info'
export const AUTH_PROFILE_ACTIVATE = (accountId) => `/auth/profile/${accountId}/activate`
export const AUTH_PROFILE_REMODERATE = (accountId) => `/auth/profile/${accountId}/remoderate`;
export const AUTH_PROFILES_ALL = '/auth/profiles/all';
